<template>
  <div class="center-xs block-image">
    <img
      class="w-100"
      :src="`/assets/${ imagesShow }`"
      alt="Wait partner"
      :width="selectedWait ? 740 : 796"
      :height="selectedWait ? 567 : 579"
      loading="eager"
      fetchpriority="high"
    >
  </div>
</template>

<script>
export default {
  name: 'HomeWaitPartners',
  mounted () {
    this.selectedWait = Math.floor(Math.random() * 2)
  },
  data () {
    return {
      selectedWait: 0,
      max: 1
    }
  },
  computed: {
    imagesShow () {
      switch (this.selectedWait) {
        case 0: return 'coming-soon.svg';
        case 1: return 'wait.svg'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .block-image {
    overflow: hidden;
    max-height: 660px;
    @media (max-width: 991px) {
      max-height: 430px;
    }
    @media (max-width: 768px) {
      max-height: 330px;
    }
    @media (max-width: 500px) {
      max-height: 230px;
    }
    img {
      position: relative;
      top: -70px;
      max-height: 839px;
      @media (max-width: 991px) {
        top: -40px;
      }
      @media (max-width: 375px) {
        top: -20px;
      }
    }
  }
</style>
